export default {
  title: 'Aplicații',
  fields: {
    id: 'ID',
    name: 'Nume',
    app_bundle_identifier: 'ID Bundle Aplicație',
    released: 'Lansat',
    franchise: 'Brand',
    app_icon: 'Pictogramă Aplicație',
    status: 'Stare',
    play_store_link: 'Link Play Store',
    apple_store_link: 'Link Apple Store',
    dynamic_link: 'Link Dinamic - Coduri QR',
  },
  filters: {
    name: 'Nume',
    released: 'Lansat',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Pregătit pentru construire',
    in_work: '🔧 În lucru',
    in_review: '📝 În revizuire',
    rejected: '❌ Respins',
    released: '✅ Lansat',
    deactivated: '🛑 Dezactivat',
  },
  card: {
    overdue: 'Întârziat · {{time}}',
    copied: 'Copiat în clipboard',
    released_tag: {
      both: '✅ Lansat',
      ios: 'iOS Lansat',
      android: 'Android Lansat',
    },
    tags: {
      has_tech_issue: 'Problemă tehnică',
    },
  },
  status_modal: {
    title: 'Actualizează starea lansării',
    status_label: 'Stare',
    note_label: 'Notă (opțional)',
    note_placeholder: 'Adaugă o notă opțională pentru această schimbare de stare',
    tech_issue_checkbox: 'Există o problemă tehnică',
    save: 'Salvează',
    cancel: 'Anulează',
  },
  released: {
    yes: 'Da',
    no: 'Nu',
  },
  configured_status: {
    true: 'Da',
    false: 'Nu',
  },
  delete_confirmation: {
    title: 'Șterge Aplicația Mobilă',
    message: 'Sigur doriți să ștergeți această aplicație mobilă?',
    buttons: {
      confirm: 'Confirmă',
      cancel: 'Anulează',
    },
  },
};
